.studentName {
  font-weight: 600;
}

.muted {
  color: var(--text-muted);
  font-size: 0.85rem;
}

/* The two actions sit together on the right of each row. Approve is the
   primary action, so it comes last — closest to where the eye lands. */
.rowActions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.dialogBody {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* The amount, restated inside the confirm dialog. An admin taking cash needs
   the figure in front of them at the moment they confirm it, not one row back
   in a table they have already stopped looking at. */
.amountCallout {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-sunken, var(--surface));
}

.amountLabel {
  color: var(--text-muted);
  font-size: 0.85rem;
}

.amountValue {
  font-size: 1.35rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.formActions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
